import React from "react";
import { Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const styles = () => ({
  root: {
    background: "",
    borderRadius: 2,
    color: "#2196F3",
    "&:hover": {
      background: "#F9F9F9"
    },
    "&:selected": {
      background: "#F6F6F6"
    }
  }
});

const SecondaryButton = ({ onClick, children, classes, disabled, ...other }) => (
  <Button
    color="primary"
    disabled={disabled}
    onClick={onClick}
    classes={{ root: classes.root }}
    {...other}
  >
    {children}
  </Button>
);
export default withStyles(styles)(SecondaryButton);
